// extracted by mini-css-extract-plugin
module.exports = {"payments":"Payment_payments__2pkEK","infoText":"Payment_infoText__eVYXD","info":"Payment_info__14GAl","linkBtn":"Payment_linkBtn__3-bOY"};